import http from "@http"

//列表  分页
export function getApparatusList(data) {
    return http({
        url: '/lskj-data/api/data/apparatus/list',
        method: "post",
        data
    })
}
//列表  不分页
export function getApparatusAll(data) {
    return http({
        url: '/lskj-data/api/data/apparatus/all',
        method: "post",
        data
    })
}

//查询单条
export function apparatusById(data) {
    return http({
        url: `/lskj-data/api/data/apparatus/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function apparatusAdd(data) {
    return http({
        url: '/lskj-data/api/data/apparatus/add',
        method: "post",
        data
    })
}

//修改
export function updeteApparatus(data) {
    return http({
        url: `/lskj-data/api/data/apparatus`,
        method: "put",
        data
    })
}
//删除
export function deleteApparatus(data) {
    return http({
        url: `/lskj-data/api/data/apparatus?ids=${data.ids}`,
        method: "delete",
        data
    })
}